var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveDiagnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e64064;\n      }\n\n      .cls-2 {\n        fill: #fae725;\n      }\n\n      .cls-3 {\n        fill: #c3156b;\n      }\n\n      .cls-4 {\n        fill: #40b3a5;\n      }\n\n      .cls-5 {\n        fill: #61beb8;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 128,
    cy: 128,
    r: 90
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,82.45c-6.05-8.45-15.94-13.96-27.13-13.96-18.41,0-33.33,14.92-33.33,33.33,0,8,2.82,15.35,7.52,21.09l52.94,64.59V82.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "128 146.99 128 187.51 146.26 165.23 146.26 146.99 128 146.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.26,123.04v-18.26h23.95v18.26h10.63l.1-.13c4.7-5.75,7.52-13.09,7.52-21.09,0-18.41-14.92-33.33-33.33-33.33-11.19,0-21.08,5.51-27.13,13.96v40.59h18.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "170.21 123.04 170.21 104.79 158.23 104.79 158.23 165.25 170.21 165.25 170.21 146.99 188.46 146.99 188.46 123.04 170.21 123.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "158.23 104.79 146.26 104.79 146.26 123.04 128 123.04 128 146.99 146.26 146.99 146.26 165.25 158.23 165.25 158.23 104.79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDiagnosis);
export default __webpack_public_path__ + "static/media/active-diagnosis.4787f9f8e3d0ee833141a390a813dc15.svg";
export { ForwardRef as ReactComponent };